import { ComponentClassNames } from '../../util/classNames';
import { ZIndex } from '../../util/styles/zIndex';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { defaultHeaderHeight } from './PageLayout.styles';

type PageLayoutBannerClassNames = ComponentClassNames<'globalBanner'>;

export const getClassNames = memoizeFunction((hasHeader: boolean): PageLayoutBannerClassNames => {
  const headerHeight = hasHeader ? defaultHeaderHeight : 0;

  return mergeStyleSets({
    globalBanner: {
      position: 'fixed',
      width: '100%',
      top: headerHeight,
      zIndex: ZIndex.PageLayoutBanner,
    },
  });
});
